import { RadioItemInterface } from "../models/interfaces/radio-item.interface";
import { LoanTypeEnum } from "../models/enum/loan-type.enum";
import { OwnershipReasonEnum } from "../models/enum/ownership-reason.enum";
import { PaymentMethodEnum } from "../models/enum/payment-method.enum";
import { StampDutyValuationEnum } from "../models/enum/stamp-duty-valuation.enum";
import { HDBLinks } from "./shared/links";
import { IDTypeEnum } from "../models/enum/id-type.enum";
export const Radio_Attend_HDB: RadioItemInterface[] = [
  {
    id: 1,
    description: "Yes",
    value: true,
    variant: "default"
  },
  {
    id: 2,
    description: "No",
    value: false,
    variant: "default"
  },
]

export const Radio_Has_Property: RadioItemInterface[] = [
  {
    id: 1,
    description: "Yes",
    value: true,
    variant: "default"
  },
  {
    id: 2,
    description: "No",
    value: false,
    variant: "default"
  },
]
export const Radio_Dispose_Property: RadioItemInterface[] = [
  {
    id: 1,
    description: "Yes",
    value: true,
    variant: "default"
  },
  {
    id: 2,
    description: "No",
    value: false,
    variant: "default"
  },
]

export const isRelatedToOwner: RadioItemInterface[] = [
  {
    id: 1,
    description: "Yes",
    value: true,
    variant: "default"
  },
  {
    id: 2,
    description: "No",
    value: false,
    variant: "default"
  }
]
export const IdTypes: RadioItemInterface[] = [
  {
    id: 1,
    description: "NRIC number",
    value: IDTypeEnum.uinfin,
    variant: "default"
  },
  {
    id: 2,
    description: "Foreign Identification Number (FIN)",
    value: IDTypeEnum.foreign_id,
    variant: "default"
  }
]


export const Radio_Cpf_Refund: RadioItemInterface[] = [
  {
    id: 1,
    description: "Full refund",
    value: 'full',
    variant: "default"
  },
  {
    id: 2,
    description: "Partial refund",
    value: 'partial',
    variant: "default"
  },
  {
    id: 3,
    description: "Zero refund",
    value: 'none',
    variant: "default"
  },
]

export const Radio_Submit_Consent: RadioItemInterface[] = [
  {
    id: 1,
    description: "Yes",
    value: true,
    variant: "default"
  },
  {
    id: 2,
    description: "No, I am engaging the Registrar to execute, sign or endorse all necessary documents relating to this application as provided in my court order",
    value: false,
    variant: "default"
  },
]


export const Radio_Has_Outstanding_Loan: RadioItemInterface[] = [
  {
    id: 1,
    description: "Yes",
    value: "yes",
    variant: "default"
  },
  {
    id: 2,
    description: "No",
    value: "no",
    variant: "default"
  }
]

export const Radio_Divorce_Situation: RadioItemInterface[] = [
  {
    id: 1,
    description: "Divorce",
    value: OwnershipReasonEnum.divorce,
    variant: "default"
  },
  {
    id: 2,
    description: "Inclusion of a new owner due to marriage",
    value: OwnershipReasonEnum.inclusion_due_to_marriage,
    variant: "default"
  },
  {
    id: 3,
    description: "Current owner moving out due to marriage",
    value: OwnershipReasonEnum.moving_out_due_to_marriage,
    variant: "default"
  },
]

export const Radio_Moving_Situations: RadioItemInterface[] = [
  {
    id: 1,
    description: "Moving out due to marriage",
    value: OwnershipReasonEnum.moving_out_due_to_marriage,
    variant: "default"
  },
  {
    id: 2,
    description: "Moving out due to other reasons",
    value: OwnershipReasonEnum.moving_out_others,
    variant: "default"
  },
]


export const Radio_Loan_Types: RadioItemInterface[] = [
  {
    id: 1,
    description: "No Loan",
    value: LoanTypeEnum.no_loan,
    variant: "default"
  },
  {
    id: 2,
    description: "HDB Loan (if eligible)",
    value: LoanTypeEnum.hdb_loan,
    variant: "default"
  },
  {
    id: 3,
    description: "Bank Loan",
    value: LoanTypeEnum.bank_loan,
    variant: "default"
  },
]

export const Payment_Method: RadioItemInterface[] = [
  {
    id: 1,
    description: "Credit Card/Debit Card ",
    value: PaymentMethodEnum.card,
    variant: "default"
  },
  {
    id: 2,
    description: "PayNow",
    value: PaymentMethodEnum.paynow,
    variant: "default"
  },
]

export const Stamp_Duty_Valuation: RadioItemInterface[] = [
  {
    id: 1,
    description: "Apply for a valuation report from HDB.",
    value: StampDutyValuationEnum.hdb,
    variant: "default"
  },
  {
    id: 2,
    description: <div>Use HDB’s latest <a rel="noopener noreferrer" href={HDBLinks.median_resale_prices} target="_blank" className="polymer-text-links">Quarterly Median Resale Prices</a> by Town and Flat Type, if available.</div>,
    value: StampDutyValuationEnum.hdb_resale_price,
    variant: "default"
  },
  {
    id: 3,
    description: "My / Our opinion of the market value of the flat, subject to legislation and any penalties payable to IRAS, if IRAS takes a different view. ",
    value: StampDutyValuationEnum.own_opinion,
    variant: "default"
  }

]

export const RepresentByRegistrar: RadioItemInterface[] = [
  {
    id: 1,
    description: "Yes",
    value: true,
    variant: "default"
  },
  {
    id: 2,
    description: "No",
    value: false,
    variant: "default"
  },
]
export const HealthDeclarationItems: RadioItemInterface[] = [
  {
    id: 1,
    description: "Yes",
    value: "Y",
    variant: "default"
  },
  {
    id: 2,
    description: "No",
    value: "N",
    variant: "default"
  }]
